import { isLiveStream, isLiveStreamLive, isLiveStreamReplay, isStreamingIdle, } from '@core/livestream/helpers';
/**
 * Checks if a video has products
 */
export function hasProducts(video) {
    const hasProductsOnVideo = !isLiveStream(video) && video.products.length > 0;
    const hasProductsOnTrailer = isStreamingIdle(video, null) && video.products.length > 0;
    const hasProductsOnLiveLiveStream = isLiveStreamLive(video) && video.live_stream_has_products;
    const hasProductsOnReplayLiveStream = isLiveStreamReplay(video) && video.live_stream_has_products;
    return Boolean(hasProductsOnVideo ||
        hasProductsOnTrailer ||
        hasProductsOnLiveLiveStream ||
        hasProductsOnReplayLiveStream);
}
